import { type IconType } from "@jsq/ds/core";
import { PaymentMethod } from "../../../../common/enums";
import {
  type DetailedPaymentPrefUnionObjectType,
  type RedactedPaymentPref,
} from "../../common/types";
import { getPaymentMethod } from "../../common/utils";

export const getPaymentMethodIconType = (
  paymentPref: DetailedPaymentPrefUnionObjectType | RedactedPaymentPref,
): IconType => {
  const paymentMethod = getPaymentMethod(paymentPref);

  switch (paymentMethod) {
    case PaymentMethod.ACH:
      return "university";
    case PaymentMethod.Wire:
      return "money-bill-transfer";
    case PaymentMethod.Check:
      return "money-check";
    default:
      return "badge-dollar";
  }
};
